export const CHATVENTAS_SET_USER = 'CHATVENTAS_SET_USER';
export const CHATVENTAS_RESET = 'CHATVENTAS_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
